import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 37518 22793"
    {...props}
  >
    <defs>
      <style>
        {/* {".str2{stroke:#2b2a29;stroke-width:959.149}.fil1{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974592728800">
        <path
          d="M36127 272H1391C775 272 272 728 272 1284v20226c0 556 503 1012 1119 1012h34736c615 0 1119-456 1119-1012V1284c0-556-504-1012-1119-1012zM25818 20198c-4861 0-8801-3940-8801-8801s3940-8801 8801-8801 8801 3940 8801 8801-3940 8801-8801 8801z"
          style={{
            fill: "none",
            // stroke: "#1c1b17",
            strokeWidth: 543.735,
          }}
          className="stroke1"
        />
        <path
          d="m30636 7517-322-391-237 447c-976 1837-1679 2996-3090 3397l8-8c285-304 503-622 668-961 21-45 42-91 62-137 100-229 177-467 235-716 29-124 53-251 73-381 4-26 8-53 12-79 48-341 67-701 69-1084 1-532-33-1106-78-1734l-17-225-213-72c-36-12-72-24-109-35-13-4-27-9-42-13-21-7-42-13-64-19-18-6-37-12-56-17-14-4-29-8-43-12-543-151-1102-228-1667-228-219 0-440 12-659 35-19 2-38 4-56 6-21 3-42 5-62 8-35 4-70 8-105 13-11 2-23 4-35 6-38 5-75 11-112 17l-36 6c-44 8-87 15-131 24-285 55-567 130-841 223-91 32-182 65-271 100l-471 186 351 364c46 47 91 94 136 140 1091 1136 1837 2003 2068 3026 59 261 84 533 73 822l-21-36c-861-1540-2343-2005-4507-2537l-218-54-134 181c-640 862-1049 1884-1181 2957-30 240-46 482-47 724-2 145 2 289 11 433l31 506 455-223 105-51c14-7 29-14 44-21 19-9 37-18 56-28l57-27 18-9c49-23 98-46 145-70l15-6c26-13 52-25 78-38 2-1 5-2 7-3 51-24 102-48 152-71 3-2 7-4 11-6 21-9 42-19 63-28 14-7 28-14 42-20 17-8 34-16 51-23 31-15 63-29 94-43 6-3 11-5 17-8 34-15 68-30 101-45h1c558-248 1076-441 1570-546 6-1 11-2 17-4 19-4 38-7 57-11 596-116 1156-96 1737 105 8 2 15 5 23 8 13 4 25 9 37 13-1756 330-2667 1608-3848 3510l-118 192 129 183c623 875 1469 1579 2448 2037 352 164 718 296 1090 391l490 127-71-501c-290-2053-401-3409 503-4565-105 814 30 1560 418 2337 45 91 93 181 144 272 26 45 52 91 79 136 55 91 112 182 173 275 335 509 770 1053 1336 1723l145 172 215-67c1024-321 1956-908 2694-1698 264-284 503-592 709-915l272-428-499-87c-2040-359-3366-672-4186-1889 4 2 7 4 11 5 12 6 24 11 37 17 24 11 48 22 73 33 13 6 26 11 39 17 23 9 46 19 70 29 12 5 24 9 36 14 25 9 49 19 74 28 9 4 19 7 29 11 27 9 54 19 82 29 6 1 12 3 18 5 31 10 63 21 94 30 1 0 2 0 3 1 356 107 719 160 1097 160 1074 0 2226-434 3513-958l208-85 3-225c10-1074-260-2141-783-3086-187-339-407-661-652-957zm-4168 4379-127 168-191 86c-104 47-216 71-332 71-67 0-133-8-197-24l-199-50-151-139c-141-127-232-301-258-487l-30-225 88-205c80-190 234-345 423-427l221-97 240 41c209 35 393 150 519 322l137 188 17 232c1 20 2 39 2 59 0 177-56 346-162 487z"
          className="fil1"
          style={{
            // stroke: "#1c1b17",
            strokeWidth: 414.326,
          }}
        />
        <rect
          width={10842}
          height={1631}
          x={2759}
          y={2697}
          rx={544}
          ry={433}
          style={{
            strokeWidth: 959.149,
          }}
          className="fil1"
        />
        <rect
          width={10842}
          height={1631}
          x={2759}
          y={6503}
          rx={544}
          ry={433}
          style={{
            strokeWidth: 959.149,
          }}
          className="fil1"
        />
        <rect
          width={10842}
          height={1631}
          x={2759}
          y={10309}
          rx={544}
          ry={433}
          style={{
            strokeWidth: 959.149,
          }}
          className="fil1"
        />
        <rect
          width={10842}
          height={1631}
          x={2759}
          y={14361}
          rx={544}
          ry={433}
          style={{
            strokeWidth: 959.149,
          }}
          className="fil1"
        />
        <rect
          width={10842}
          height={1631}
          x={2759}
          y={18465}
          rx={544}
          ry={433}
          style={{
            strokeWidth: 959.149,
          }}
          className="fil1"
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
